<template>
  <!-- 商业件下单 -->
  <div class="business"
       v-loading.fullscreen.lock="fullscreenLoading">
    <el-dialog title="请输入代收货款"
               :visible.sync="paymentPrice_show"
               @close='recoverAgency'
               width="30%">
      <div class="paymentPrice_view">
        <el-input v-model="paymentPrice"
                  placeholder="请输入货款金额"
                  type="number"></el-input>
        <span>{{offerDetails.hbtype}}</span>
      </div>
      <span class="hinttext">*到付运费需手续费</span>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="cancelData">取 消</el-button>
        <el-button type="primary"
                   @click="paymentPrice_show = false">确 定</el-button>
      </span>
    </el-dialog>
    <div class="business_view">
      <!-- =======地址库组件=======-->
      <address-book :site_list_show='site_list_show'
                    :recipients='recipients'
                    :stateId='addressID'
                    :isFba='isfba'
                    @submitpack='submitpack'>

      </address-book>
      <!-- ===========智能填写弹框=========== -->
      <el-dialog title="智能填写"
                 :visible.sync="smartInput"
                 width="500px">
        <el-input type="textarea"
                  :rows="7"
                  placeholder="请将地址粘贴在此处"
                  v-model="smartInput_text">
        </el-input>
        <span slot="footer"
              class="dialog-footer">
          <el-button @click=" smartInput = false">取 消</el-button>
          <el-button type="primary"
                     @click="analysisSite">确 定</el-button>
        </span>
      </el-dialog>
      <!-- ===========标题=========== -->
      <div class="business_view_title">
        <span>创建订单</span>
      </div>
      <!-- ===========交货方式=========== -->
      <div class="business_view_way">
        <div class="view_title">
          <span>交货方式：</span>
        </div>
        <el-radio-group v-model="deliveryType">
          <el-radio-button label="1"
                           v-if="userPayOrder.zj"
                           border>自寄仓库</el-radio-button>
          <el-radio-button label="2"
                           v-if="userPayOrder.sm"
                           border>上门取件</el-radio-button>
          <el-radio-button label="3"
                           v-if="userPayOrder.zs"
                           border>自送仓库</el-radio-button>
        </el-radio-group>
      </div>
      <!-- ===========不同交货方式需要填写的内容=========== -->
      <div class="business_order_num"
           v-if="deliveryType==1">
        <div class="view_title">
          <span>物流单号：</span>
        </div>
        <el-input v-model="kdnum"
                  @input="check_num()"
                  placeholder="请输入已发出的快递单号"></el-input>
      </div>
      <div class="business_order_num"
           v-if="deliveryType==2">
        <div class="view_title">
          <span>取件时间</span>
        </div>
        <el-date-picker v-model="collectData.date"
                        type="date"
                        placeholder="选择日期"
                        :picker-options="pickerOptions">
        </el-date-picker>
      </div>
      <div class="business_order_num"
           v-if="deliveryType==2">
        <div class="view_title">
          <span>取件备注</span>
        </div>
        <el-input v-model="collectData.remark"
                  type='textarea'
                  :rows="2"
                  placeholder="请输入取件备注"></el-input>

      </div>

      <!-- ===========地址展示=========== -->
      <div class="siteView">
        <div class="business_order_address">
          <div class="view_title">
            <div class="title_left">
              <span class="box_title">{{deliveryType==2?'取':'寄'}}</span>
              <span class="title_text">{{deliveryType==2?'取件地址':'寄方信息'}}</span>
            </div>
            <div class="title_right">
              <el-link target="_blank"
                       @click="showAddressBook(1)"
                       :underline="false"> <i class="el-icon-notebook-1"></i> 地址簿</el-link>

              <el-link target="_blank"
                       :underline="false"
                       @click="smartInput=true"> <i class="el-icon-document-checked"></i> 智能填写</el-link>

            </div>
          </div>
          <el-form label-position="top"
                   label-width="80px"
                   :model="jj"
                   ref="jj"
                   class="jjForm">

            <el-form-item class="place_order_form_item"
                          prop="username"
                          :rules="[{required: true, message: '联系人姓名不能为空'}]"
                          label="姓名">
              <el-input v-model="jj.username"
                        placeholder="请填写联系人姓名"></el-input>
            </el-form-item>

            <el-form-item class="place_order_form_item"
                          label="公司名称">
              <el-input v-model="jj.companyname"
                        placeholder="请填写公司名称"></el-input>
            </el-form-item>

            <el-form-item class="place_order_form_item"
                          label="电话"
                          prop="mobile"
                          :rules="[{required: true, message: '联系电话不能为空'}]">
              <el-input v-model="jj.mobile"
                        placeholder="请填写联系电话"></el-input>
            </el-form-item>

            <el-form-item class="place_order_form_item"
                          label="统编"
                          prop="companytaxid">
              <el-input v-model="jj.companytaxid"
                        placeholder="请输入统编"></el-input>
            </el-form-item>

            <el-form-item class="place_order_form_item"
                          prop="site"
                          :rules="[{required: true, message: '省市区不能为空'}]"
                          label="省市区">
              <el-cascader v-model="jj.site"
                           placeholder="请选择您所在的地区"
                           :options="cnSite"></el-cascader>
            </el-form-item>

            <el-form-item class="place_order_form_item"
                          label="邮政编码">
              <el-input v-model="jj.zipcode"
                        placeholder="请填写联系电话"></el-input>
            </el-form-item>

            <el-form-item class="place_order_form_item_max"
                          prop="address"
                          :rules="[{required: true, message: '详细地址不能为空'}]"
                          label="详细地址">
              <el-input v-model="jj.address"
                        placeholder="请填写所在街道以及详细地址"></el-input>
            </el-form-item>
          </el-form>
          <div class="saveSite">
            <el-checkbox v-model="jj.save"
                         v-if="!jj.id">保存到地址簿</el-checkbox>
            <el-link target="_blank"
                     @click="resetData(1)">重置</el-link>
          </div>

        </div>

        <div class="borderView"></div>

        <div class="consignee_address">
          <div class="view_title">
            <div class="title_left">
              <span class="box_title">收</span>
              <span class="title_text">收方信息</span>
            </div>
            <div class="title_right">
              <el-link target="_blank"
                       v-if="!sj.id&&offerDetails.fba!=1"
                       @click="showAddressBook(2)"
                       :underline="false"> <i class="el-icon-notebook-1"></i> 地址簿</el-link>
            </div>
          </div>
          <el-form label-position="top"
                   label-width="80px"
                   :model="sj"
                   ref="sj"
                   v-if="offerDetails.fba!=1"
                   class="sjForm">

            <el-form-item class="place_order_form_item"
                          prop="username"
                          :rules="[{required: true, message: '联系人姓名不能为空'}]"
                          :label="sj.type!=3?'姓名':'仓库代码' ">
              <el-input v-model="sj.username"
                        :disabled='sj.type==3'
                        placeholder="请填写联系人姓名"></el-input>
            </el-form-item>

            <el-form-item class="place_order_form_item"
                          label="公司名称"
                          v-if="sj.type!=3">
              <el-input v-model="sj.companyname"
                        placeholder="请填写公司名称"></el-input>
            </el-form-item>

            <el-form-item class="place_order_form_item"
                          label="电话"
                          v-if="sj.type!=3"
                          prop="mobile"
                          :rules="[{required: true, message: '联系电话不能为空'}]">
              <el-input v-model="sj.mobile"
                        placeholder="请填写联系电话"></el-input>
            </el-form-item>

            <el-form-item class="place_order_form_item"
                          label="统编"
                          v-if="sj.type!=3"
                          prop="companytaxid">
              <el-input v-model="sj.companytaxid"
                        placeholder="请填写统编"></el-input>
            </el-form-item>

            <el-form-item class="place_order_form_item"
                          label="仓库所在城市"
                          v-if="sj.type==3"
                          prop="city">
              <el-input v-model="sj.city"
                        disabled
                        placeholder="请填写仓库所在城市"></el-input>
            </el-form-item>

            <el-form-item class="place_order_form_item"
                          prop="site"
                          v-if="sj.type!=3"
                          label="省市区">
              <el-cascader v-model="sj.site"
                           placeholder="请选择您所在的地区"
                           :options="active_site_data"></el-cascader>
            </el-form-item>

            <el-form-item class="place_order_form_item"
                          prop="zipcode"
                          label="邮政编码">
              <el-input v-model="sj.zipcode"
                        :disabled='sj.type==3'
                        placeholder="请填写联系电话"></el-input>
            </el-form-item>

            <el-form-item class="place_order_form_item_max"
                          prop="address"
                          label="详细地址">
              <el-input v-model="sj.address"
                        :disabled='sj.type==3'
                        placeholder="请填写所在街道以及详细地址">
              </el-input>
            </el-form-item>
          </el-form>
          <div class="fbaSelect"
               v-else>
            <div class="fbaSelect_top">
              <el-select v-model="userSelectFba"
                         filterable
                         @change='selectedFba'
                         placeholder="请选择您寄往的FBA地址/此报价只支持FBA">
                <el-option v-for="item in offerDetails.fbainfo"
                           :key="item.fbaid"
                           :label="item.fbacode + '（ '+item.zipcode+' ）'"
                           :value="item.fbacode">
                </el-option>
              </el-select>
            </div>
            <div class="fbaSelect_bottom">
              <el-descriptions class="margin-top"
                               :column="3"
                               size="small"
                               border>

                <el-descriptions-item>
                  <template slot="label">
                    代码
                  </template>
                  {{userSelectFbaDetails.code}}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    邮编
                  </template>
                  {{userSelectFbaDetails.zipcode}}
                </el-descriptions-item>
                <el-descriptions-item>
                  <template slot="label">
                    城市
                  </template>
                  {{userSelectFbaDetails.city}}
                </el-descriptions-item>

                <el-descriptions-item>
                  <template slot="label">
                    详细地址
                  </template>
                  {{userSelectFbaDetails.address}}
                </el-descriptions-item>
              </el-descriptions>

            </div>
          </div>
          <div class="saveSite">
            <el-checkbox v-if="!sj.id&&offerDetails.fba!=1"
                         v-model="sj.save">保存到地址簿</el-checkbox>
            <el-link target="_blank"
                     v-if="offerDetails.fba!=1"
                     @click="resetData(2)">重置</el-link>
          </div>
        </div>
      </div>

      <!-- ===========装箱单填写=========== -->
      <div class="packingList">
        <packing-list :tableData='zxd_info'
                      :xzinfo='xzdInfoData'>
        </packing-list>
      </div>

      <!-- ===========其他信息填写=========== -->
      <div class="otherInfo">
        <div class="view_title">
          <span>更多服务：</span>
        </div>
        <div>
          <div>
            <el-checkbox :disabled="offerDetails.iscdf==0"
                         v-model="additionData.cdf"
                         @change='hintBG'>出口报关</el-checkbox>
            <el-checkbox v-model="additionData.dsk"
                         @change='paymentGoods'>代收货款</el-checkbox>
          </div>

          <el-radio-group v-model="playType">
            <el-radio :label="1">寄方付款</el-radio>
            <el-radio :label="2"
                      :disabled='offerDetails.isdsall==0||offerDetails.isdsall==1'>到付运费（只到付运费）</el-radio>
          </el-radio-group>
        </div>
      </div>

      <!-- ===========上传文件=========== -->
      <div class="otherInfo">
        <div class="view_title">
          <span>上传文件：</span>
        </div>
        <el-upload class="upload-demo"
                   :action="upUrl"
                   :multiple='false'
                   :data='{pd:"upbgfile",op:"post"}'
                   name='bgfile'
                   :limit='1'
                   :on-exceed="exceedFile"
                   :on-remove="removeFile"
                   :on-success="successUpload"
                   :accept='accept'>
          <el-button size="small"
                     type="primary">点击上传</el-button>
          <div slot="tip"
               class="el-upload__tip">根据需求上传报关或其他文件，可后期上传，详情请咨询客服。</div>
        </el-upload>
      </div>

    </div>
    <!-- 下单按钮 -->
    <div class="placeOrder_bottom">
      <el-button type="primary"
                 size="mini"
                 @click="dataVerify">确定下单</el-button>
    </div>
  </div>
</template>

<script>
import AddressParse from 'address-parse';
import common from '@/assets/js/common';
import addressBook from '@/components/addressBook'
import packingList from '@/components/packingList'
import { apiFba, apiZHCN, apiOffer, apiOrderDetails, apiUserWarehouse } from '@/request/api'
export default {
  data () {
    return {

      upUrl: '',

      //--------用户选择的FBA地址详情-------
      userSelectFbaDetails: {

      },
      //--------用户选择的FBA地址--------
      userSelectFba: '',
      //--------用户支持的下单方式--------
      userPayOrder: {
        zj: false,
        sm: false,
        zs: false
      },
      //--------限制上传文件--------
      accept: '.xls, .xlsx, .csv',
      //--------上传文件数据--------
      uploadData: {},
      //--------代收货款金额--------
      paymentPrice: '',
      //--------是否显示代收货款--------
      paymentPrice_show: false,
      //--------日期配置--------
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24;
        },
        shortcuts: [{
          text: '今天',
          onClick (picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '明天',
          onClick (picker) {
            const date = new Date();
            date.setTime(date.getTime() + 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }]
      },
      //--------取件日期--------
      collectData: {
        date: '',
        remark: ''
      },
      //--------报价详情--------
      offerDetails: {},
      //--------付款类型--------
      playType: 1,
      //--------其他信息--------
      additionData: {
        cdf: false,
        dsk: false
      },
      //--------装箱单数据--------
      zxd_info: [{

        no: 1,
        chang: 1,
        kuan: 1,
        gao: 1,
        weight: 1,
        wpinfo: [{

          name: '',
          enname: '',
          num: ''
        }]
      }],
      //--------地址数据--------
      smartInput_text: '',
      //--------是否显示智能填写--------
      smartInput: false,
      //--------地址数据--------
      active_site_data: [],
      // ----------该国家是否支持fba-----------
      isfba: false,
      // ----------国家ID-----------
      addressID: '',
      // ----------判断是否为寄件地址-----------
      recipients: 1,
      // ----------是否显示地址库数据-----------
      site_list_show: {
        flag: false
      },
      // ----------收件信息-----------
      sj: {
        username: '',
        companyName: '',
        mobile: '',
        site: '',
        address: '',
        zipcode: '',
        save: true
      },
      // ----------寄件信息-----------
      jj: {
        username: '',
        companyName: '',
        mobile: '',
        site: '',
        address: '',
        zipcode: '',
        save: true
      },
      // -----------中国国家地区选择-----------
      cnSite: [],
      // -----------寄货方式-----------
      deliveryType: "1",
      // -----------快递单号-----------
      kdnum: '',
      // -----------全局加载-----------
      fullscreenLoading: false,
    }
  },
  computed: {
    xzdInfoData () {
      if (this.offerDetails.extinfo) {
        return this.offerDetails.extinfo.packAstrictInfo
      } else {
        return {}
      }

    }
  },
  methods: {

    //---------选择了FBA地址---------
    async selectedFba (e) {
      let res = await apiFba({
        pd: 'list',
        addrid: this.addressID,
        fbacode: e,
        pageSize: 1
      })
      if (res.errno == 0) {
        this.userSelectFbaDetails = res.fbalist[0]
      } else {
        this.userSelectFbaDetails = {}
      }
    },
    //---------获取仓库列表---------
    async getUserWarehouse () {
      let res = await apiUserWarehouse({

      })
      if (res.errno == 0) {
        res.fromtype.forEach(e => {
          if (e == 1) {
            this.userPayOrder.zj = true
          } else if (e == 2) {
            this.userPayOrder.sm = true
          } else if (e == 3) {
            this.userPayOrder.zs = true
          }
        });
      }
    },
    //  -----------上传成功回调-----------
    successUpload (e) {
      this.uploadData = e
      this.$message(e.message)
    },
    //  -----------移除文件-----------
    removeFile (e) {
      this.$message.success('成功移除' + e.name + '文件')

    },
    //  -----------超出提醒-----------
    exceedFile (e) {
      this.$message.error('您已经上传了' + e[0].name + '文件,请先删除。')
    },
    //  -----------数据校验-----------
    dataVerify () {
      if (this.deliveryType == 1 && this.kdnum == '') {
        return this.$message.error('自寄快递，单号不能为空')
      } else if (this.deliveryType == 2 && this.collectData.date == '') {
        return this.$message.error('上门取件，取件时间不能为空')
      }
      this.$refs.jj.validate((valid) => {
        if (!valid) {
          this.$message.error('寄件信息未填写完整')
          return false;
        }
      });

      if (this.$refs.sj) {
        this.$refs.sj.validate((valid) => {
          if (!valid) {
            this.$message.error('收件信息未填写完整')
            return false;
          }
        })
      }


      for (const key in this.zxd_info) {
        for (const k in this.zxd_info[key].wpinfo) {
          if (this.zxd_info[key].wpinfo[k] == '') {
            this.$message.error('装箱单物品信息未填写完整')
            return false
          }
        }
      }
      return this.affirmPlaceOrder()

    },
    //  -----------确定下单-----------
    async affirmPlaceOrder () {
      this.fullscreenLoading = true
      const jjren = JSON.stringify({
        'mobile': this.jj.mobile,
        'username': this.jj.username,
        'address': this.jj.address,
        'zipcode': this.jj.zipcode,
        'province': this.jj?.site[0],
        'city': this.jj?.site[1],
        'district': this?.jj.site[2],
        'addrid': this.addrid,
        'type': 1,
        'companyname': this.jj.companyname,
        'companytaxid': this.jj.companytaxid,
      })
      const sjren = JSON.stringify(this.userSelectFba || this.sj.type == 3 ? '' : {
        'mobile': this.sj.mobile,
        'username': this.sj.username,
        'address': this.sj.address,
        'zipcode': this.sj.zipcode,
        'province': this.sj.type ? this.sj.province : this.sj?.site[0],
        'city': this.sj.type ? this.sj.city : this.sj.site[1],
        'district': this.sj.type ? this.sj.district : this.sj?.site[2],
        'addrid': this.addressID,
        'type': this.sj.type ? this.sj.type : 2,
        'companyname': this.sj.companyname,
        'companytaxid': this.sj.companytaxid,
      })
      let res = await apiOrderDetails({
        op: 'post',
        pd: 'app_post',
        item: 'saveall',
        type: 1,
        fromtype: this.deliveryType,
        kdnum: this.deliveryType == 1 ? this.kdnum : '',
        bgfile: this.uploadData?.fileurl || '',
        qjstartime: this.deliveryType == 2 ? this.collectData.date : '',
        qjendtime: this.deliveryType == 2 ? this.collectData.date : '',
        qjbzinfo: this.deliveryType == 2 ? this.collectData.remark : '',
        jjren: jjren,
        sjren: this.userSelectFba || this.sj.type == 3 ? '' : sjren,
        fbaid: this.userSelectFba ? this.userSelectFbaDetails.id : sjren == '' ? this.sj.id : '',
        cdf: this.additionData.cdf ? 1 : 0,
        cid: this.$route.query.bjid,
        paytype: this.playType,
        dsprice: this.paymentPrice,
        ckid: this.$route.query.ckid,
        bgnum: this.zxd_info.length,
        zxdinfo: JSON.stringify(this.zxd_info)
      })
      if (res.errno == 0) {
        this.$notify({
          title: '订单下单成功',
          message: res.message,
          type: 'success',
          duration: 2000,
          close: () => {
            this.$router.go(0)
          }
        });
      } else {
        this.$message.error(res.message)
      }
      this.fullscreenLoading = false
    },
    //  -----------取消数据-----------
    cancelData () {
      this.additionData.dsk = false
      this.paymentPrice = ''
      this.paymentPrice_show = false
    },
    //  -----------恢复数据-----------
    recoverAgency (e) {
      if (this.paymentPrice == '') {
        this.additionData.dsk = false
      }
    },
    //  -----------代收款-----------
    paymentGoods (e) {
      if (e) {
        this.paymentPrice_show = true
      } else {
        this.paymentPrice = ''
        this.paymentPrice_show = false
      }
    },
    //  -----------报关提示框-----------
    hintBG (e) {
      if (e) {
        this.$confirm('报关需要手续费￥' + this.offerDetails.cdf + '元', '确定报关吗', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
        }).catch(() => {
          this.additionData.cdf = false
        });
      }
    },
    //  -----------获取报价详情-----------
    async getOfferDetails () {
      this.fullscreenLoading = true
      let res = await apiOffer({
        bjid: this.$route.query.bjid,
        weight: 1
      })
      if (res.errno == 0) {
        this.offerDetails = res.allbj[0]
      } else {
        this.$message.error(res.message)
      }
      this.fullscreenLoading = false

    },
    //   -------开始智能填写-------
    analysisSite () {
      let data = AddressParse.parse(this.smartInput_text)
      let details = data[0].details
      let reg = new RegExp('\市|\省|\行政区|\自治区', 'g')
      data = JSON.stringify(data[0])
      var a = JSON.parse(data.replace(reg, ""));
      a.details = details
      this.jj = {
        username: a.name,
        companyName: '',
        mobile: a.mobile,
        site: [a.province, a.city],
        address: a.details,
        zipcode: a.zip_code,
        save: true
      }
      if (a.area !== '') {
        this.jj.site.push(a.area)
      }
      this.$refs.jj.resetFields();

      this.smartInput = false
    },
    //   -------重置数据格式-------
    resetData (type) {
      if (type == 2) {
        this.sj = {
          username: '',
          companyName: '',
          mobile: '',
          site: '',
          address: '',
          zipcode: '',
          save: true
        }
        this.$refs.sj.resetFields();
      } else {
        this.jj = {
          username: '',
          companyName: '',
          mobile: '',
          site: '',
          address: '',
          zipcode: '',
          save: true
        }
        this.$refs.jj.resetFields();

      }

    },
    //   -------获取中国数据-------
    async getCnData () {
      this.fullscreenLoading = true
      let res = await apiZHCN({
        all: 1,
      })
      this.cnSite = res.gjlist.CN.children
      this.fullscreenLoading = false
    },
    //   -------获取当前国家数据-------
    async getActiveData () {
      this.fullscreenLoading = true
      let res = await apiZHCN()
      let arr = []
      for (const key in res.gjlist) {
        if (res.gjlist[key].value == this.addressID) {
          arr.push(res.gjlist[key])
        }
      }
      this.active_site_data = arr[0].children
      this.fullscreenLoading = false
    },
    // ----------- 选择了地址-----------
    submitpack (i, item) {
      if (this.recipients == 1) {
        this.jj = item
        this.jj.site = [this.jj.province, this.jj.city]
      } else {
        if (item.code) {
          this.sj = {
            address: item.address,
            addrid: item.addrid,
            city: item.city,
            companyname: 'FBA',
            isdefault: '0',
            site: item.site,
            type: 3,
            username: item.code,
            zipcode: item.zipcode,
            id: item.id
          }
        } else {
          this.sj = item
          this.sj.site = [this.sj.province, this.sj.city]
        }

      }
    },
    // ----------- 获取FBA地址簿数据-----------
    async get_FBA_address () {
      if (!(this.offerDetails.fba != 2)) {
        this.isfba = false
        return
      }
      this.fullscreenLoading = true
      let res = await apiFba({
        pd: 'list',
        addrid: this.addressID,
        pageSize: 1
      })
      if (res.fbalist[0]) {
        this.isfba = true
      } else {
        this.isfba = false
      }
      this.fullscreenLoading = false

    },
    // ----------- 显示地址簿-----------
    showAddressBook (type) {
      this.recipients = type
      this.site_list_show.flag = true
    },
    // -----------  快递单输入限制-----------
    check_num: common.debounce(function () {
      this.kdnum = this.kdnum.replace(/[^\a-\z\A-\Z0-9\-]/g, '');
    })

  },
  components: {
    addressBook,
    packingList
  },
  created () {
    this.upUrl = this.$store.state.upUrl;
    this.getUserWarehouse()
    this.getOfferDetails()
    this.getActiveData()
    this.getCnData()
    this.addressID = this.$route.query.addrid
    this.get_FBA_address()
  }
}
</script>

<style lang='scss'>
.business {
  overflow: auto;
  box-sizing: border-box;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  padding-top: 10px;
  display: flex;
  background-color: #fff;
  padding-bottom: 80px;
  .hinttext {
    font-style: 10px;
    color: #999;
  }
  .paymentPrice_view {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .el-input {
      width: 80%;
    }
    span {
      font-size: 20px;
    }
  }
  .placeOrder_bottom {
    height: 100px;
    background: rgba(255, 255, 255, 0.815);
    position: fixed;
    bottom: 0;
    right: 0;
    left: 10%;
    z-index: 100;
    display: flex;
    align-items: center;
    padding: 20px;
    justify-content: flex-end;
    box-sizing: border-box;
  }
  //   ---------地址库---------
  .siteView {
    width: 100%;
    display: flex;
    height: 450px;
    justify-content: space-between;
    .borderView {
      width: 1px;
      height: 100%;
      background-color: #eee;
    }
    .consignee_address {
      width: 45%;
      .box_title {
        background-color: #67c23a;
      }
    }
    .box_title {
      width: 30px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      color: #fff;
      border-radius: 4px;
      background-color: #409eff;
    }
  }

  .business_view {
    width: 90%;
    //   ---------通用---------
    .business_order_num,
    .business_order_address,
    .business_view_way {
      width: 100%;
      display: flex;
      align-items: center;
      height: 70px;
    }
    .otherInfo {
      display: flex;
      margin-top: 50px;
      padding-bottom: 50px;
      .el-radio-group {
        margin-top: 20px;
      }
      .el-checkbox-group {
        margin-top: 20px;

        // margin-left: 50px;
      }
    }
    //   ---------装箱单---------
    .packingList {
      width: 100%;
      .packingList_module_view,
      .el-input {
        width: 90%;
      }
    }
    //   ---------地址库---------
    .business_order_address,
    .consignee_address {
      width: 45%;
      display: flex;
      align-items: flex-start;
      flex-direction: column;
      justify-content: space-between;
      .fbaSelect {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;

        .fbaSelect_top {
          flex: 1;
          max-height: 70px;
          display: flex;
          align-items: center;
          .el-select {
            width: 100%;
          }
        }
        .fbaSelect_bottom {
          flex: 1;
        }
      }
      .saveSite {
        width: 100%;
        display: flex;
        justify-content: flex-end;

        .el-checkbox__inner {
          border-radius: 50%;
        }
        .el-link {
          margin-left: 20px;
        }
      }
      .view_title {
        width: 100%;

        display: flex;
        justify-content: space-between;
        margin-top: 15px;
        margin-bottom: 15px;
        .title_left {
          height: 100%;
          display: flex;
          align-items: center;
        }
        .title_right {
          .el-link {
            margin-left: 30px;
          }
        }
      }
      .title_text {
        margin-left: 10px;
        font-size: 18px;
        color: #333;
        font-weight: 700;
      }
      .el-form {
        box-sizing: border-box;
        width: 100%;
        padding-left: 50px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        .el-form-item__label {
          padding: 0;
          height: 30px;
        }
        .el-input__inner {
          border-top: 0;
          border-left: 0;
          border-radius: 0;
          border-right: 0;
          padding-left: 0;
        }
        .el-form-item {
          //   margin-bottom: 10px;
        }
        .place_order_form_item_max {
          width: 100%;
          .el-cascader {
            width: 100%;
          }
        }
        .place_order_form_item {
          width: 40%;
          .el-cascader {
            width: 100%;
          }
        }
      }
    }
    //   ---------快递单号---------
    .business_order_num {
      .el-input {
        width: 300px;
      }
    }
    .business_view_way {
      border-top: 1px solid #eee;
      .el-radio-group {
        display: flex;
        align-items: center;
        .el-radio.is-bordered {
          margin-right: 0px;
        }
      }
    }
    .view_title {
      width: 100px;
      display: flex;
      font-size: 16px;
      color: #333;
    }
    .business_view_title {
      margin-top: 20px;
      height: 80px;
      width: 100%;
      display: flex;
      justify-content: center;
      font-size: 30px;
      color: #409eff;
      font-weight: 700;
      letter-spacing: 2px;
    }
  }
}
</style>